export default {
    usernameRequiredRule: '请输入账号',
    usernamePlaceholder: '请输入账号',
    passwordRequiredRule: '请输入密码',
    passwordPlaceholder: '请输入密码',
    login: '登录'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/login.js